"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ConfirmActionButton;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ActionIconButton = _interopRequireDefault(require("./ActionIconButton"));
var _ConfirmationDialog = _interopRequireDefault(require("./ConfirmationDialog"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ConfirmActionButton(_ref) {
  let {
    title,
    confirmationMessage = undefined,
    onAction,
    busy = false,
    disabled = false,
    children
  } = _ref;
  const [showConfirmation, setShowConfirmation] = (0, _react.useState)(false);
  function onConfirm(isConfirmed) {
    setShowConfirmation(false);
    if (isConfirmed) {
      onAction();
    }
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ActionIconButton.default, {
    onAction: () => setShowConfirmation(true),
    title: title,
    busy: busy,
    disabled: disabled
  }, children), showConfirmation && /*#__PURE__*/_react.default.createElement(_ConfirmationDialog.default, {
    title: title,
    message: confirmationMessage,
    onConfirm: onConfirm
  }));
}
ConfirmActionButton.defaultProps = {
  busy: false,
  disabled: false
};
ConfirmActionButton.propTypes = {
  title: _propTypes.default.string.isRequired,
  confirmationMessage: _propTypes.default.string,
  onAction: _propTypes.default.func.isRequired,
  busy: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  children: _propTypes.default.node.isRequired
};